import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    mediaQuery,
} from '@gumtree/ui-library/src/base/theme';

export const BannerContainer = styled.div<{ isVisible?: boolean }>`
    box-sizing: border-box;
    height: 64px;
    width: 100%;
    position: relative;
    background-color: #fff;
    padding: 8px 8px 8px 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    /* Hide on desktop to prevent layout shift */
    ${mediaQuery.from(breakpoints.medium)} {
        display: none;
    }
`;

export const BannerCloseButton = styled.button`
    height: 100%;
    width: 32px;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.blade};
`;

export const BannerContentWrap = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`;

export const BannerContent = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`;

export const gumtreeIconStyle = css`
    width: 30px;
    height: 38px;
    color: #72EF36;
`;

export const AppIcon = styled.div`
    width: 48px;
    height: 48px;
    background-color: #0d475c;
    color: #0d475c;
    flex-shrink: 0;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BannerText = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 8px;
`;

export const BannerTitle = styled.div`
    font-size: ${fontSizes.small};
    font-weight: ${fontWeights.bold};
    color: #3C3241;
    line-height: 20px;
    letter-spacing: 1%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const BannerSubtitle = styled.div`
    font-size: ${fontSizes.msmall};
    color: #3C3241;
    line-height: 16px;
    letter-spacing: 1%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 4px;
`;

export const GetButton = styled.button`
    font-size: ${fontSizes.medium};
    font-weight: ${fontWeights.bold};
    line-height: 36px;
    padding: 0 16px;
    font-size: ${fontSizes.small};
    border-radius: 4px;
    border: none;

    background: ${colors.gtGreen};
    color: #0D475C;
    letter-spacing: 1%;
`;

